import { ChartsPanelComponent } from '../field-view-toolbar/charts-panel/charts-panel.component';
import { ControlPanelComponent } from '../field-view-toolbar/control-panel/control-panel.component';
import { DataPanelComponent } from '../field-view-toolbar/data-panel/data-panel.component';
import { EventsPanelComponent } from '../field-view-toolbar/events-panel/events-panel.component';
import { LayersPanelComponent } from '../field-view-toolbar/layers-panel/layers-panel.component';
import { MeasurePanelComponent } from '../field-view-toolbar/measure-panel/measure-panel.component';
import { WeatherPanelComponent } from '../field-view-toolbar/weather-panel/weather-panel.component';

const _popoutWindowKeys = [
  'popout_charts_panel',
  'popout_control_panel',
  'popout_data_panel',
  'popout_events_panel',
  'popout_layers_panel',
  'popout_measure_panel',
  'popout_weather_panel'
] as const;

export type PopoutWindowKey = (typeof _popoutWindowKeys)[number];

export const fieldViewPopoutComponentMap: Record<PopoutWindowKey, { component: any; selector: string }> = {
  popout_charts_panel: { component: ChartsPanelComponent, selector: 'app-charts-panel' },
  popout_control_panel: { component: ControlPanelComponent, selector: 'app-control-panel' },
  popout_data_panel: { component: DataPanelComponent, selector: 'app-data-panel' },
  popout_events_panel: { component: EventsPanelComponent, selector: 'app-events-panel' },
  popout_layers_panel: { component: LayersPanelComponent, selector: 'app-layers-panel' },
  popout_measure_panel: { component: MeasurePanelComponent, selector: 'app-measure-panel' },
  popout_weather_panel: { component: WeatherPanelComponent, selector: 'app-weather-panel' }
};
